import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { SERVER_URL } from '../constants';
import { formatDate, formatTime } from '../helpers/Helpers';
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import SchedulesCalendarControl from './SchedulesCalendarControl';
import SchedulesCalendarCustomerList from './SchedulesCalendarCustomerList';
import SchedulesCalendarTimeSlotList from './SchedulesCalendarTimeSlotList';
import dayjs from 'dayjs';
import ScheduleCreate from './ScheduleCreate';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
    padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    },
}));
  
function SchedulesCalendar (props) {
    
    
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };

    const [schedules, setSchedules] = useState([]);

    const [selectedSchedule, setSelectedSchedule] = useState(null);

    const [newScheduleData, setNewScheduleData] = useState(null);

    const [calendarControlKey, setCalendarControlKey] = React.useState(0);

    const remountCalendarControl = () => {
        setCalendarControlKey(prevKey => prevKey + 1); // Changing the key forces re-mount
    };

    const [isLoading, setIsLoading] = React.useState(false);
    const [highlightedDays, setHighlightedDays] = React.useState([]);

    const fetchSchedulesList = (date, preSelectLatest = false) => {
        // console.log("fetchSchedulesList ", date);
      const token = sessionStorage.getItem("token");
      fetch(SERVER_URL + 'api/mod/list-office-schedules-month/' + props.officeId + '/' + date.format("YYYY-MM"), {
          method: 'GET',
          headers: { 
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization' : 'Bearer ' + token
          }
      })
      .then(response => response.json())
      .then(data => {
            // console.log("fetchSchedulesList data.data", data.data);
            // if (data.data.length < 1) setMessaage("No schedules");
            setSchedules(data.data);
            setHighlightedDays(data.data.map(item => dayjs(item.date).date()));
            if (preSelectLatest)
            {
                const latestSchedule = data.data.reduce((max, item) => item.id > max.id ? item : max, data.data[0]);
                setSelectedSchedule(latestSchedule);
            }
            setIsLoading(false);
      })
      .catch(err => console.error(err));
    }

    return(
        <React.Fragment>
            <IconButton
                    onClick={handleClickOpen}
                    size="medium"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
                <CalendarMonthIcon fontSize='large' sx={{ color: 'gray' }} />
            </IconButton>
            <BootstrapDialog
            sx={{
                "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                    width: "auto", // Let content define width
                    maxWidth: "calc(100vw - 32px)", // Prevent overflow on small screens
                    minWidth: "300px", // Optional: set a minimum width
                },
                },
            }}
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            >

            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0}
                >
                    <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                    Schedules Calendar
                    </Typography>
                    <Typography variant="body1">
                    {props.officeName}
                    </Typography>
                </Stack>
            </DialogTitle>
            
            <DialogContent
                sx={{
                    m: 0,
                    p: 0,
                    overflowX: "auto", // Prevent horizontal scroll
                    maxWidth: "100%",     // Ensure it doesn't exceed parent
                    boxSizing: "border-box", // Respect padding and borders
                }}
            dividers
            >
                <SchedulesCalendarControl 
                    setNewScheduleData={setNewScheduleData} 
                    setHighlightedDays={setHighlightedDays} 
                    setIsLoading={setIsLoading} 
                    isLoading={isLoading} 
                    highlightedDays={highlightedDays} 
                    schedules={schedules} 
                    fetchSchedulesList={fetchSchedulesList} 
                    key={calendarControlKey} 
                    setSelectedSchedule={setSelectedSchedule} 
                    officeId={props.officeId}
                />
                {selectedSchedule && selectedSchedule.type == 1 ? 
                    <SchedulesCalendarCustomerList 
                        maxClients={selectedSchedule.max_clients}
                        startTime={selectedSchedule.start_time} 
                        setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} 
                        fetchSchedulesList={fetchSchedulesList} 
                        remountCalendarControl={remountCalendarControl} 
                        setSelectedSchedule={setSelectedSchedule}
                        schedule={selectedSchedule}  
                        fetchOffices={props.fetchOffices} 
                        averageServeMinutes={selectedSchedule.average_serve_minutes} 
                        officeId={props.officeId} hideButton={false} 
                        date={formatDate(selectedSchedule.date)} 
                        rawDate={selectedSchedule.date} 
                        officeName={props.officeName} 
                        scheduleId={selectedSchedule.id} 
                    />
                : null}
                {selectedSchedule && selectedSchedule.type == 2 ? 
                    <SchedulesCalendarTimeSlotList 
                        averageServeMinutes={selectedSchedule.average_serve_minutes} 
                        startTime={selectedSchedule.start_time} 
                        setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} 
                        fetchSchedulesList={fetchSchedulesList} 
                        remountCalendarControl={remountCalendarControl} 
                        setSelectedSchedule={setSelectedSchedule} 
                        schedule={selectedSchedule}  
                        fetchOffices={props.fetchOffices} 
                        officeId={props.officeId} 
                        hideButton={false} 
                        date={formatDate(selectedSchedule.date)} 
                        rawDate={selectedSchedule.date} 
                        officeName={props.officeName} 
                        scheduleId={selectedSchedule.id} 
                    />
                : null}
                {newScheduleData ? 
                    <ScheduleCreate 
                        newScheduleData={newScheduleData} 
                        scheduleDate={formatDate(newScheduleData.date)} 
                        setNewScheduleData={setNewScheduleData} 
                        fetchSchedulesList={fetchSchedulesList} 
                        officeId={props.officeId} 
                        date={formatDate(newScheduleData.date)} 
                        rawDate={newScheduleData.date} 
                        officeName={props.officeName} 
                        scheduleId={newScheduleData.office_id} 
                        setSelectedSchedule={setSelectedSchedule}
                    />
                : null}
            </DialogContent>
                
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default SchedulesCalendar;